import { render, staticRenderFns } from "./attached-file.vue?vue&type=template&id=2cbb4873&"
import script from "./attached-file.vue?vue&type=script&lang=js&"
export * from "./attached-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports